"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showTooltipOnHover = exports.showTooltipOnClick = void 0;
var React = __importStar(require("react"));
exports.showTooltipOnClick = function (children, showClick, setShowClick) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onClick: function (event) {
                    setShowClick(!showClick);
                    if (child.props.onClick) {
                        child.props.onClick(event);
                    }
                },
            });
        }
        else {
            return React.createElement("span", { onClick: function () { return setShowClick(!showClick); } },
                " ",
                child,
                " ");
        }
    });
};
exports.showTooltipOnHover = function (children, setShowHover) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onMouseEnter: function (event) {
                    setShowHover(true);
                    if (child.props.onMouseEnter) {
                        child.props.onMouseEnter(event);
                    }
                },
                onMouseLeave: function (event) {
                    setShowHover(false);
                    if (child.props.onMouseLeave) {
                        child.props.onMouseLeave(event);
                    }
                },
            });
        }
        else {
            return (React.createElement("span", { onMouseEnter: function () { return setShowHover(true); }, onMouseLeave: function () { return setShowHover(false); } }, child));
        }
    });
};
